import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Course } from 'lms-api';
import { UserCourseDataService } from 'lms-api';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-course-content-display',
  templateUrl: './course-content-display.component.html',
  styleUrls: ['./course-content-display.component.scss']
})
export class CourseContentDisplayComponent implements OnInit {
  @Input() course: Course;
  @Output() pendingStatusChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private ucdService: UserCourseDataService
  ) { }

  ngOnInit() {
  }

  public activateCourse() {
    if(this.course.type.includes("Webinar") || this.course.userData?.Status == 'CE Available' || this.course.userData?.Status == 'CE Earned') return;
    this.pendingStatusChange.emit(true);
    this.ucdService.StartCourse(this.course).pipe(
      switchMap(course => {
        return this.ucdService.ActivateCE(course);
      })
    ).subscribe(course => {
      this.pendingStatusChange.emit(false);
    });
  }

}
